import React from 'react';
import { useTheme } from '@zydalabs/storefront-components';
import { Typography } from '@zydalabs/zac-react';
import { useIsMobile } from 'common/hooks';
import { localizeCurrency } from 'common/utils';
import useTranslation from 'next-translate/useTranslation';
import { StyledItemWrapper, StyledDiscountedPriceWrapper, StyledField, StyledPrice, StyledOldPrice } from './style';
import { StyledAlignItemsBetween } from '../../../../common/styles';
import { Country } from '../../../../service/types';

type VariantOptionFieldType = {
  fieldTitle: string;
  additionalInfo?: React.ReactNode;
  price?: number;
  discountedPrice?: number;
  isDisabled?: boolean;
  currency?: Country['currency'];
};

const VariantOptionField: React.FC<VariantOptionFieldType> = ({
  fieldTitle,
  additionalInfo,
  price,
  discountedPrice,
  isDisabled,
  currency,
}) => {
  const theme: any = useTheme();
  const isMobile = useIsMobile();
  const { lang } = useTranslation();
  const currencyTitle = currency?.title_en;

  return (
    <StyledItemWrapper>
      <StyledAlignItemsBetween>
        <StyledField>
          <Typography
            variant={isMobile ? 'body16' : 'body14'}
            color={theme.color.headlineText}
            my={0}
            isDisabled={isDisabled}
            testId="field-title"
          >
            {fieldTitle}
          </Typography>
          {additionalInfo && additionalInfo}
        </StyledField>
        {currencyTitle && !discountedPrice && !!price && (
          <Typography
            variant={isMobile ? 'body16' : 'body14'}
            color={theme.color.headlineText}
            isDisabled={isDisabled}
            testId="price"
          >
            {localizeCurrency(lang, { amount: price, currency: currencyTitle })}
          </Typography>
        )}
        {currencyTitle && discountedPrice && !!price && (
          <StyledDiscountedPriceWrapper>
            <StyledPrice>
              <Typography
                variant={isMobile ? 'body16' : 'body14'}
                color={theme.color.headlineText}
                isDisabled={isDisabled}
                testId="discounted-price"
              >
                {localizeCurrency(lang, { amount: discountedPrice, currency: currencyTitle })}
              </Typography>
              <StyledOldPrice>
                <Typography variant="body14" color={theme.color.disabled} testId="old-price">
                  {localizeCurrency(lang, { amount: price, currency: currencyTitle })}
                </Typography>
              </StyledOldPrice>
            </StyledPrice>
          </StyledDiscountedPriceWrapper>
        )}
      </StyledAlignItemsBetween>
    </StyledItemWrapper>
  );
};
export default VariantOptionField;
